import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { haptic, Haptick } from '../../../utils/helper';
import './Navigation.scss';
import React from 'react';

const Naviagtion = () => {
    const { t } = useTranslation();

    const menuList: Array<{
        icon: React.JSX.Element;
        text: string;
        link?: string;
        open?: Function;
    }> = [
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.15739 22.7426C3.91474 24.5 6.74317 24.5 12.4 24.5C18.0568 24.5 20.8853 24.5 22.6426 22.7426C24.4 20.9853 24.4 18.1568 24.4 12.5C24.4 6.84314 24.4 4.01472 22.6426 2.25736C20.8853 0.5 18.0568 0.5 12.4 0.5C6.74317 0.5 3.91474 0.5 2.15739 2.25736C0.400024 4.01472 0.400024 6.84314 0.400024 12.5C0.400024 18.1568 0.400024 20.9853 2.15739 22.7426ZM20.5 17.3C20.5 17.797 20.0971 18.2 19.6 18.2H5.20002C4.70297 18.2 4.30002 17.797 4.30002 17.3C4.30002 16.803 4.70297 16.4 5.20002 16.4H19.6C20.0971 16.4 20.5 16.803 20.5 17.3ZM19.6 13.4C20.0971 13.4 20.5 12.997 20.5 12.5C20.5 12.003 20.0971 11.6 19.6 11.6H5.20002C4.70297 11.6 4.30002 12.003 4.30002 12.5C4.30002 12.997 4.70297 13.4 5.20002 13.4H19.6ZM20.5 7.7C20.5 8.19705 20.0971 8.6 19.6 8.6H5.20002C4.70297 8.6 4.30002 8.19705 4.30002 7.7C4.30002 7.20295 4.70297 6.8 5.20002 6.8H19.6C20.0971 6.8 20.5 7.20295 20.5 7.7Z"
                        fill="#8993A7"
                    />
                </svg>
            ),
            text: t('nav.menu'),
            link: '/menu',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="21"
                    viewBox="0 0 25 21"
                    fill="none">
                    <path
                        d="M12.2001 9.25C14.5197 9.25 16.4001 7.29125 16.4001 4.875C16.4001 2.45875 14.5197 0.5 12.2001 0.5C9.88046 0.5 8.00005 2.45875 8.00005 4.875C8.00005 7.29125 9.88046 9.25 12.2001 9.25Z"
                        fill="#8993A7"
                    />
                    <path
                        d="M12.2001 20.5C16.1765 20.5 19.4001 18.5413 19.4001 16.125C19.4001 13.7088 16.1765 11.75 12.2001 11.75C8.2236 11.75 5.00003 13.7088 5.00003 16.125C5.00003 18.5413 8.2236 20.5 12.2001 20.5Z"
                        fill="#8993A7"
                    />
                    <path
                        d="M6.34652 1.75C6.55947 1.75 6.76737 1.77176 6.96812 1.8132C6.47905 2.71808 6.20006 3.7626 6.20006 4.875C6.20006 5.96031 6.46563 6.98103 6.93277 7.87045C6.743 7.90729 6.547 7.92658 6.34652 7.92658C4.64921 7.92658 3.27327 6.5439 3.27327 4.83829C3.27327 3.13268 4.64921 1.75 6.34652 1.75Z"
                        fill="#8993A7"
                    />
                    <path
                        d="M3.20003 16.125C3.20003 17.3425 3.65533 18.3839 4.33684 19.2325C2.02078 19.0673 0.200012 17.7555 0.200012 16.1618C0.200012 14.5828 1.98934 13.2807 4.27497 13.0959C3.62791 13.93 3.20003 14.9448 3.20003 16.125Z"
                        fill="#8993A7"
                    />
                    <path
                        d="M18.2 4.875C18.2 5.96031 17.9344 6.98103 17.4673 7.87045C17.6571 7.90729 17.8531 7.92658 18.0536 7.92658C19.7509 7.92658 21.1268 6.5439 21.1268 4.83829C21.1268 3.13268 19.7509 1.75 18.0536 1.75C17.8406 1.75 17.6328 1.77176 17.432 1.8132C17.921 2.71808 18.2 3.7626 18.2 4.875Z"
                        fill="#8993A7"
                    />
                    <path
                        d="M24.2 16.1618C24.2 17.7555 22.3792 19.0673 20.0632 19.2325C20.7447 18.3839 21.2 17.3425 21.2 16.125C21.2 14.9448 20.7721 13.93 20.125 13.0959C22.4107 13.2807 24.2 14.5828 24.2 16.1618Z"
                        fill="#8993A7"
                    />
                </svg>
            ),
            text: t('nav.team'),
            link: '/team',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.9306 0.506115C10.0308 0.499966 10.1369 0.499979 10.2731 0.500003H13.7274C13.8636 0.499979 13.9696 0.499966 14.0699 0.506115C15.3424 0.584168 16.4567 1.39749 16.9322 2.59533C16.9697 2.68972 17.0033 2.79164 17.0462 2.92247L17.05 2.93349C17.1499 3.20616 17.3795 3.5162 17.7007 3.7639C17.7365 3.79148 17.7725 3.8175 17.8084 3.84202C20.393 3.84507 21.7422 3.89339 22.6721 4.65962C22.8629 4.8168 23.0372 4.99337 23.1924 5.18654C24 6.19164 24 7.68035 24 10.6578C24 11.4134 24 11.7911 23.819 12.0857C23.7839 12.1431 23.7439 12.1974 23.6998 12.2481C23.4731 12.5083 23.1157 12.6169 22.4011 12.8339L16.8 14.5356V13.5634C16.8 12.2211 15.7255 11.133 14.4 11.133H9.6C8.27452 11.133 7.2 12.2211 7.2 13.5634V14.5356L1.59888 12.8339C0.88428 12.6169 0.52698 12.5083 0.300252 12.2481C0.256092 12.1974 0.21618 12.1431 0.180936 12.0857C-5.36442e-08 11.7911 0 11.4134 0 10.6578C0 7.68035 7.15256e-08 6.19164 0.807576 5.18654C0.962796 4.99337 1.13716 4.8168 1.32791 4.65962C2.25784 3.89339 3.60698 3.84507 6.19168 3.84202C6.22762 3.81749 6.26353 3.79144 6.29932 3.76387C6.62074 3.51612 6.85025 3.20606 6.95027 2.93346C6.99581 2.79507 7.02988 2.69185 7.0682 2.59532C7.54372 1.39749 8.65802 0.584168 9.9306 0.506115ZM15.3824 3.62078C15.4115 3.6956 15.4434 3.76931 15.4781 3.84181H8.52206C8.55671 3.76943 8.58864 3.69584 8.61762 3.62115L8.61948 3.6169L8.62448 3.60487L8.63033 3.59014L8.63582 3.57559L8.64019 3.5635L8.64233 3.55742L8.64742 3.54254L8.65201 3.52882L8.65452 3.5212L8.6578 3.51107L8.66048 3.50251L8.66263 3.4955C8.70923 3.35417 8.72444 3.31011 8.73829 3.27522C8.95444 2.73076 9.46095 2.36106 10.0393 2.32559C10.0781 2.32322 10.1255 2.32281 10.2976 2.32281H13.7028C13.8749 2.32281 13.9224 2.32322 13.961 2.32559C14.5394 2.36106 15.046 2.73076 15.2622 3.27522C15.2758 3.3096 15.2903 3.35206 15.3376 3.49546L15.3396 3.50241L15.3424 3.51101L15.3456 3.52117L15.3481 3.52876L15.3527 3.54246L15.3578 3.55731L15.3599 3.56339L15.3643 3.57545L15.3697 3.58991L15.3756 3.60449L15.3805 3.61638L15.3824 3.62078ZM14.4 12.9558H9.6C9.26863 12.9558 9 13.2279 9 13.5634V16.1901C9 16.4385 9.14938 16.6619 9.37716 16.7542L10.2173 17.0946C11.3617 17.558 12.6383 17.558 13.7827 17.0946L14.6228 16.7542C14.8506 16.6619 15 16.4385 15 16.1901V13.5634C15 13.2279 14.7313 12.9558 14.4 12.9558ZM7.21291 16.4424L1.20703 14.6179C1.24314 18.4026 1.46147 21.8882 2.7815 23.0764C4.36312 24.5 6.90871 24.5 11.9999 24.5C17.091 24.5 19.6367 24.5 21.2183 23.0764C22.5383 21.8882 22.7566 18.4026 22.7927 14.6179L16.787 16.4424C16.6956 17.3327 16.1246 18.1091 15.2914 18.4466L14.4511 18.787C12.8777 19.4243 11.1223 19.4243 9.54882 18.787L8.70866 18.4466C7.87536 18.1091 7.30442 17.3327 7.21291 16.4424Z"
                        fill="#8993A7"
                    />
                </svg>
            ),
            text: t('nav.matrix'),
            link: '/areas',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="21"
                    viewBox="0 0 25 21"
                    fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22.9372 17.1334C22.984 16.961 22.8535 16.7953 22.681 16.8H19.7618C16.4809 16.8 13.589 14.1109 13.589 10.5C13.589 6.88909 16.4809 4.20001 19.7618 4.20001L22.681 4.2C22.8535 4.20465 22.984 4.0389 22.9372 3.86662C22.7049 3.01169 22.3364 2.28303 21.7452 1.66949C20.8796 0.771457 19.7819 0.372913 18.4259 0.183769C17.1083 -3.49045e-05 15.4247 -2.2957e-05 13.299 5.26476e-07H10.8553C8.72968 -2.2957e-05 7.04606 -3.49045e-05 5.72842 0.183769C4.37236 0.372913 3.27478 0.771457 2.4092 1.66949C1.54362 2.56753 1.15948 3.70627 0.977176 5.11318C0.800015 6.48023 0.800027 8.227 0.800049 10.4323V10.5677C0.800027 12.773 0.800015 14.5198 0.977176 15.8868C1.15948 17.2937 1.54362 18.4325 2.4092 19.3306C3.27478 20.2285 4.37236 20.627 5.72842 20.8163C7.04606 21 8.72969 21 10.8553 21H13.299C15.4247 21 17.1083 21 18.4259 20.8163C19.7819 20.627 20.8796 20.2285 21.7452 19.3306C22.3364 18.717 22.7051 17.9882 22.9372 17.1334ZM5.71572 14.1C5.71572 14.597 6.1041 15 6.58319 15C7.06227 15 7.45066 14.597 7.45066 14.1V6.9C7.45066 6.40295 7.06227 6 6.58319 6C6.1041 6 5.71572 6.40295 5.71572 6.9V14.1Z"
                        fill="#8993A7"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22.6819 6C22.7558 5.99998 22.8271 5.99996 22.8927 6.00424C23.8641 6.06789 24.7231 6.85658 24.7954 7.95816C24.8001 8.0287 24.8001 8.10461 24.8 8.17534V12.8247C24.8001 12.8954 24.8001 12.9713 24.7954 13.0418C24.7231 14.1434 23.8641 14.9321 22.8927 14.9958C22.8288 15 22.7595 15 22.6876 15H19.7619C17.3703 15 15.324 13.0469 15.324 10.5C15.324 7.95309 17.3703 6.00002 19.7619 6.00002L22.6819 6ZM20.6194 10.5C20.6194 11.1628 20.1203 11.7 19.5047 11.7C18.889 11.7 18.3898 11.1628 18.3898 10.5C18.3898 9.83724 18.889 9.3 19.5047 9.3C20.1203 9.3 20.6194 9.83724 20.6194 10.5Z"
                        fill="#8993A7"
                    />
                </svg>
            ),
            text: t('nav.wallet'),
            link: '/wallet',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none">
                    <path
                        d="M1.75712 1.7571C3.41874 0.0954975 6.03789 0.00493207 11.1 0V5.89631C10.5739 5.47514 9.9534 5.16045 9.26696 4.98885C6.68327 4.34294 4.34298 6.68321 4.98889 9.26688C5.1605 9.95331 5.47519 10.5738 5.89637 11.0999H0C0.00493212 6.03783 0.0954984 3.41871 1.75712 1.7571Z"
                        fill="#8993A7"
                    />
                    <path
                        d="M1.75712 22.2429C0.0954984 20.5813 0.00493212 17.9622 0 12.9002H9.7956C9.38929 14.6202 7.84405 15.9002 5.99986 15.9002C5.50279 15.9002 5.09984 16.3032 5.09984 16.8003C5.09984 17.2973 5.50279 17.7003 5.99986 17.7003C8.23196 17.7003 10.1644 16.4173 11.1 14.5485V24C6.03789 23.9951 3.41874 23.9045 1.75712 22.2429Z"
                        fill="#8993A7"
                    />
                    <path
                        d="M12.9001 24C17.9622 23.9951 20.5812 23.9045 22.2429 22.2429C23.9045 20.5813 23.9951 17.9622 24 12.9002H14.2044C14.6107 14.6202 16.156 15.9002 18.0002 15.9002C18.4973 15.9002 18.9002 16.3032 18.9002 16.8003C18.9002 17.2973 18.4973 17.7003 18.0002 17.7003C15.768 17.7003 13.8356 16.4173 12.9001 14.5485V24Z"
                        fill="#8993A7"
                    />
                    <path
                        d="M22.2429 1.7571C23.9045 3.41871 23.9951 6.03783 24 11.0999H18.1037C18.5249 10.5738 18.8395 9.95331 19.0111 9.26688C19.6571 6.68321 17.3168 4.34294 14.733 4.98885C14.0467 5.16045 13.4262 5.47514 12.9001 5.89631V0C17.9622 0.00493207 20.5812 0.0954975 22.2429 1.7571Z"
                        fill="#8993A7"
                    />
                    <path
                        d="M8.83039 6.73529C10.1643 7.06875 11.1 8.26722 11.1 9.64207V11.1001H9.64201C8.26715 11.1001 7.06867 10.1643 6.7352 8.83046C6.41886 7.56511 7.56504 6.41895 8.83039 6.73529Z"
                        fill="#8993A7"
                    />
                    <path
                        d="M12.9001 11.1001V9.64207C12.9001 8.26722 13.8358 7.06875 15.1697 6.73529C16.435 6.41895 17.5812 7.56511 17.2648 8.83046C16.9313 10.1643 15.7329 11.1001 14.358 11.1001H12.9001Z"
                        fill="#8993A7"
                    />
                </svg>
            ),
            text: t('bonus_title'),
            link: '/bonus',
        },
    ];

    return (
        <div className="border">
            <nav className="nav">
                {menuList.map((el, i) =>
                    el.link ? (
                        <NavLink
                            className="nav__item"
                            key={el.text + i + el.link}
                            to={el.link}
                            onClick={() => Haptick(haptic.medium)}>
                            {el.icon}
                            <p>{el.text}</p>
                        </NavLink>
                    ) : (
                        <div
                            onClick={() => {
                                Haptick(haptic.medium);
                                el.open && el.open();
                            }}
                            key={el.text + i + el.link}
                            className="nav__item">
                            {el.icon}
                            <p>{el.text}</p>
                        </div>
                    )
                )}
            </nav>
        </div>
    );
};

export default Naviagtion;
